import history from "../../../history";
import API from "../../../utils/endpoints";
import * as types from "./actionType";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const errorMessage = {
  status: 400,
  message: "Something went wrong",
};

function fetchigExperienceList() {
  return {
    type: types.FETCH_EXPERIENCE_LIST,
  };
}

function fetchigExperienceListSuccess(payload, count, pendingCount) {
  return {
    type: types.FETCH_EXPERIENCE_LIST_SUCCESS,
    payload,
    count,
    pendingCount,
  };
}

function fetchigExperienceListFailed() {
  return {
    type: types.FETCH_EXPERIENCE_LIST_FAILED,
  };
}

function fetchigExperienceDetails() {
  return {
    type: types.FETCH_EXPERIENCE_DETAILS,
  };
}

function fetchigExperienceDetailsSuccess(payload) {
  return {
    type: types.FETCH_EXPERIENCE_DETAILS_SUCCESS,
    payload,
  };
}

function fetchigExperienceDetailsFailed() {
  return {
    type: types.FETCH_EXPERIENCE_DETAILS_FAILED,
  };
}

function creatingExperience() {
  return {
    type: types.CREATE_EXPERIENCE,
  };
}

function creatingExperienceSuccess(payload, count) {
  return {
    type: types.CREATE_EXPERIENCE_SUCCESS,
    payload,
    count,
  };
}

function fetchingExperienceUpdatedDetails() {
  return {
    type: types.EXPERIENCE_UPDATE_DETAILS,
  };
}

function fetchingExperienceUpdatedDetailsSuccess(payload, count) {
  return {
    type: types.EXPERIENCE_UPDATE_DETAILS_SUCCESS,
    payload,
    count,
  };
}

function fetchingExperienceUpdatedDetailsFailed() {
  return {
    type: types.EXPERIENCE_UPDATE_DETAILS_FAILED,
  };
}

function creatingExperienceFailed() {
  return {
    type: types.CREATE_EXPERIENCE_FAILED,
  };
}

function updatingExperience() {
  return {
    type: types.UPDATE_EXPERIENCE,
  };
}

function updatingExperienceSuccess(payload, count) {
  return {
    type: types.UPDATE_EXPERIENCE_SUCCESS,
    payload,
    count,
  };
}

function updatingExperienceFailed() {
  return {
    type: types.UPDATE_EXPERIENCE_FAILED,
  };
}

export const fetchExperiencesList = (payload, data) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchigExperienceList());
  try {
    let response = await api.get(
      `${API.fetchToursList}?status=${payload.status}&page=${
        payload.page
      }&limit=${payload.limit}&category=${payload.category}&startDate=${
        payload.startDate
      }&endDate=${payload.endDate}&country=${
        payload.country ? payload.country : ""
      }`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchigExperienceListSuccess(
          response.data.data.wanderlustData,
          response.data.data.count,
          response.data.data.pendingCount
        )
      );
      // toast.error(response.data.message);
    } else {
      dispatch(fetchigExperienceListFailed());
      if (!data) {
        toast.error(response.data.message);
      }
    }
  } catch (error) {
    dispatch(fetchigExperienceListFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const fetchExperienceDetail = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchigExperienceDetails());
  try {
    let response = await api.get(
      `${API.fetchToursDetail}?wanderlustId=${payload}`
    );

    if (response.data.code === 200) {
      dispatch(fetchigExperienceDetailsSuccess(response.data.data));
      // toast.error(response.data.message);
    } else {
      dispatch(fetchigExperienceDetailsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchigExperienceDetailsFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const createExperience = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(creatingExperience());
  try {
    let response = await api.post(API.createTours, payload);
    if (response.data.code === 200) {
      dispatch(creatingExperienceSuccess(response.data.data));
      callback && callback();
      toast.error(response.data.message);
    } else {
      dispatch(creatingExperienceFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(creatingExperienceFailed(errorMessage));
  }
};

export const updateExperience = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(updatingExperience());
  try {
    let response = await api.put(API.createTours, payload);
    if (response.data.code === 200) {
      dispatch(updatingExperienceSuccess(response.data.data));
      callback && callback();
      toast.error(response.data.message);
    } else {
      dispatch(updatingExperienceFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(updatingExperienceFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const approveRejectUpdatedExperienceDetails = (
  payload,
  callback
) => async (dispatch, getState, api) => {
  // dispatch(createPartner());
  try {
    let response = await api.put(API.updateModeration, payload);

    if (response.data.code === 200) {
      dispatch(fetchUpdatedExperienceData(payload.wanderlustId));
      // dispatch(createPartnerSuccess(response.data.data));
      toast.error(response.data.message);
      callback && callback();
      // history.push("/partner/list");
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const deleteUpdatedExperienceDetails = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.delete(
      `${API.updateModeration}?wanderlustId=${payload.wanderlustId}&key=${payload.key}`
    );
    if (response.data.code === 200) {
      dispatch(fetchUpdatedExperienceData(payload.wanderlustId));
      // dispatch(createPartnerSuccess(response.data.data));
      toast.error(response.data.message);
      callback && callback();
      // history.push("/partner/list");
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const fetchUpdatedExperienceData = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingExperienceUpdatedDetails());
  try {
    let response = await api.get(
      `${API.updateModeration}?wanderlustId=${payload}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingExperienceUpdatedDetailsSuccess(response.data.data));
    } else {
      dispatch(fetchingExperienceUpdatedDetailsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingExperienceUpdatedDetailsFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const updateExperienceDetails = (
  payload,
  wanderlustId,
  callback
) => async (dispatch, getState, api) => {
  // dispatch(createPartner());
  try {
    let response = await api.post(
      `${API.updateModeration}?wanderlustId=${wanderlustId} `,
      payload
    );

    if (response.data.code === 200) {
      callback && callback();
      toast.error(response.data.message);
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const deleteExperienceInfo = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(deletingTourInfo());

  try {
    let response = await api.delete(
      `${API.deleteTour}?wanderlustId=${payload.wanderlustId}&status=${payload.status}&rejectionReason=${payload.rejectionReason}`
    );
    if (response.data.code === 200) {
      // dispatch(deletingTourInfoSuccess(response.data.data));
      callback && callback();
      toast.error(response.data.message);
    } else {
      // dispatch(deletingTourInfoFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(deletingTourInfoFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const ExperienceGalleryModeration = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.post(`${API.galleryModeration} `, payload);

    if (response.data.code === 200) {
      // dispatch(createPartnerSuccess(response.data.data));
      // history.push("/partner/rentals");
      callback && callback();
      toast.error(response.data.message);
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};
